import request from "@/utils/request";

export  function save(data){
  return request({
    method: "post",
    url: '/system/marketGroup/save',
    data,
  });
}
export  function del(data){
  return request({
    method: "post",
    url: '/system/marketGroup/delete',
    data,
  });
}
export  function list(data){
  return request({
    method: "post",
    url: '/system/marketGroup/getList',
    data,
  });
}
export  function detail(data){
  return request({
    method: "get",
    url: '/system/marketGroup/detail',
    params:data,
  });
}


